import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Box, Typography, Grid, Stack, Avatar, Button, Divider, Modal } from '@mui/material';
import { DefaultCard } from "../../assets/styled-components/card";
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import CustomAgGrid from '../../components/commoncomponents/CustomAgGrid';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { FemsGraph, BemsGraph, MasterGraph } from "../../utility/apiURLS";
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import axios from 'axios';
import { getAuthToken, getFacilityId, getCreatedBy } from "../../utility/tokenUtility";
import { SuccessChips, ErrorChips, WarningChips } from "../../assets/styled-components/chips";
import SectionTitle from '../commoncomponents/SectionTitle';
import moment from 'moment';
import { getTCListByID } from '../testingcommission_components/testingCommissionAPIs';
import { useDispatch } from 'react-redux';
import { DispatchAction, setBasicDetailsFields, setOthersDetailsFields } from '../../redux/actions/TestingCommission/dispatchActions';
import TCActionsTypes from "../../redux/actions/TestingCommission/TCActionTypes";
import dayjs from 'dayjs';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { createRoot } from 'react-dom/client';
import Axios from 'axios';
import Tcviewfile from '../testingcommission_components/Tcviewfile';
import PageLoader from '../commoncomponents/PageLoader'
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import { mandatoryFields } from '../../redux/actions/assetActions';
import commonMessages from "../../utility/constant";
import { FilterRounded } from '@mui/icons-material';
import VendorUnschedule from './VendorUnschedule';
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";
import VendorWorkorder from './VendorWorkorder';
import { routineInspectionCheckFormSubmitForVendor, routineInspectionClearWebForm } from '../../redux/actions/vendor/routineInspectionWebFormActions';
import { checkFormSubmitForVendor, clearWebForm } from '../../redux/actions/vendor/webFormActions';
import { scmCheckFormSubmitForVendor, scmClearWebForm } from '../../redux/actions/vendor/scmWebFormActions';

const Vendordash = () => {
    const navigate = useNavigate();

    const [isView, setIsView] = useState(false);
    const [enableDownload, setEnableDownload] = useState(false);
    const [filteredRows, setFilteredRows] = useState([]);
    const [activeTab, setActiveTab] = useState(1);
    const [rows, setRows] = useState({ workOrders: [], tc: [] });
    const [workorderrows, setWorkorderrows] = useState([]);
    const [gridApi1, setGridApi1] = useState({});
    const [gridApi2, setGridApi2] = useState({});
    const facilityId = getFacilityId();
    const token = getAuthToken("id_token");
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGT001");
    const createdBy = getCreatedBy('createdBy');
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false)
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [openReportModal, setOpenReportModal] = useState(false);
    const [serviceType, setServiceType] = useState("");
    const printRef = useRef()
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [gridLoader, setGridLoder] = useState(false);
    //state for T&C service
    const [service, setService] = useState({ id: 1, label: 'FEMS', value: 'FEMS' });
    const serviceOptions = [
        { id: 1, label: 'FEMS', value: 'FEMS' },
        { id: 2, label: 'BEMS', value: 'BEMS' },
    ];

    //pagination state
    const [filterModel, setFilterModel] = useState([]);
    const [sortModel, setSortModel] = useState([]);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [exportCount, setExportCount] = useState(0);
    const [totalDataCount, setTotalDataCount] = useState({ fem: 0, bem: 0 });
    const [initialRender, setIntialRender] = useState(true);
    const [dataCountFlag, setDataCountFlag] = useState({ fem: false, bem: false });
    const [allCounts, setAllCount] = useState(0);
    const [scheduledCount, setScheduledCount] = useState(0);
    const [unscheduledCount, setUnscheduledCount] = useState(0);
    const [workrequestCount, setWorkrequestCount] = useState(0);
    const [pdmscheduledCount, setPdmscheduledCount] = useState(0);
    const [rischeduledCount, setRischeduledCount] = useState(0);
    const [scmCount, setScmCount] = useState(0);
    const facilityid = getFacilityId();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    // const currentYear = new Date().getFullYear();
    // const [year, setYear] = useState({ label: currentYear.toString(), value: currentYear.toString() }); // Default year to current year
    // const [month, setMonth] = useState(); // Default month to "All"
    // const [monthsOptions, setMonthsOptions] = useState([]);
    // const allMonths = commonMessages.months; // Assuming `allMonths` is an array of month names.
    const ModalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "1250px",
        height: "100%",
        maxHeight: "calc(100% - 64px)",
        bgcolor: "#fff",
        boxShadow: 24,
        borderRadius: "5px",
        p: 4,
        overflowY: "auto",
        overflowX: "hidden",
    }; const StyledCardTab = styled(Button)(({ theme }) => ({
        padding: "16px",
        flexDirection: "column",
        flex: 1,
        alignItems: "start",
        borderRadius: 0,
        gap: "4px",
        textTransform: "capitalize",
        "&.active": {
            backgroundColor: "#F6F2FA",
            "& .count": {
                color: theme.palette.primary.main,
            },
        },
        "&:hover": {
            "& .count": {
                color: theme.palette.primary.main,
            },
        },
    }));

    const handleRefresh = () => {
        const refresh = true;
        fetchData(refresh)
        setPageIndex(1);
        setPageSize(10);
        setFilterModel([])
        setSortModel([])
    };

    const handleTabChange = (tabIndex) => {

        setActiveTab(tabIndex);  // Update the active tab

    };


    const allMonths = commonMessages.months; // Assuming `commonMessages.months` is an array of month names.
    const all = { label: "All", value: "All", id: "0" };
    const currentYear = new Date().getFullYear();
    const currentMonthIndex = new Date().getMonth();

    const [year, setYear] = useState(() => {
        const initialYear = currentYear.toString();
        return { label: initialYear, value: initialYear };
    });

    const [month, setMonth] = useState(() => {
        const initialMonth =
            // location?.state?.month ||
            allMonths[currentMonthIndex]; // Default to current month if not in location.state            
        return initialMonth;
    });

    const [monthsOptions, setMonthsOptions] = useState([]);
    const [yearsOptions, setYearsOptions] = useState([]);

    const fetchMaintenanceYears = async () => {
        try {
            const maintenanceYearResponse = await axios.get(
                `${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityid}?page=1&size=100`
            );
            const years = maintenanceYearResponse.data.items.map(year => ({
                label: year.maintyearvalue.toString(),
                value: year.maintyearvalue.toString(),
            }));
            setYearsOptions(years || []);
        } catch (error) {
            console.error('Error fetching maintenance years:', error);
        }
    };

    useEffect(() => {
        const selectedYear = parseInt(year.value);
        const isNextYear = currentMonthIndex === 11;

        const months =
            selectedYear === currentYear
                ? [
                    // all,
                    ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
                    ...(isNextYear ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
                ]
                : [...allMonths]; // All months for previous years

        setMonthsOptions(months);

        // if (!location?.state?.month) {

        //     setMonth(
        //         selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]
        //     );
        // }
    }, [year, currentMonthIndex]);

    const handleYearChange = (newValue) => {
        if (newValue && newValue.value !== year?.value) {
            const selectedYear = parseInt(newValue.value);
            const currentDate = new Date();
            const currentMonthIndex = currentDate.getMonth();

            const months =
                selectedYear === currentYear
                    ? [
                        // all,
                        ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
                        ...(currentMonthIndex === 11 ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
                    ]
                    : [...allMonths]; // All months for previous years

            setYear(newValue); // Keep the selected year
            setMonthsOptions(months);
            setMonth(selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]); // Default to the start of the year for future years
        }
    };

    const handleMonthChange = (newValue) => {
        setMonth(newValue);
    };


    // const fetchData = async (refresh) => {
    //     if (!refresh) {
    //         setLoading(true);
    //     }
    //     setWorkorderrows([]);
    //     setGridLoder(true);

    //     try {
    //         // Prepare requests based on activeTab value
    //         let femsSwoResponse, bemsSwoResponse, femsUswoResponse, bemsUswoResponse, femsUswoPdmResponse, bemsUswoPdmResponse, femsUswoRiResponse, bemsUswoRiResponse;

    //         if (activeTab === 2) {

    //             // Fetch all data when activeTab is 2
    //             [femsSwoResponse, bemsSwoResponse] = await Promise.all([
    //                 axios.get(`${FemsGraph}/api/VendorDashboard/GetAllVendorDashboardUSWOListAsync/${facilityId}/${createdBy}?size=1000`, config),
    //                 axios.get(`${BemsGraph}/api/VendorDashboard/GetAllVendorDashboardUSWOListAsync/${facilityId}/${createdBy}?size=1000`, config)
    //             ]);
    //         } else if (activeTab === 3) {

    //             // Only fetch SWO data when activeTab is 3
    //             [femsSwoResponse, bemsSwoResponse] = await Promise.all([
    //                 axios.get(`${FemsGraph}/api/VendorDashboard/GetAllVendorDashboardUSWOListAsync/${facilityId}/${createdBy}?size=1000`, config),
    //                 axios.get(`${BemsGraph}/api/VendorDashboard/GetAllVendorDashboardUSWOListAsync/${facilityId}/${createdBy}?size=1000`, config)
    //             ]);
    //         } else if (activeTab === 4) {

    //             // Only fetch USWO data when activeTab is 4
    //             [femsUswoResponse, bemsUswoResponse] = await Promise.all([
    //                 axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardUSWOList/${facilityId}/${createdBy}?size=1000`, config),
    //                 axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardUSWOList/${facilityId}/${createdBy}?size=1000`, config),
    //             ]);
    //         } else if (activeTab === 5) {

    //             // Only fetch USWO data when activeTab is 4
    //             [femsUswoPdmResponse, bemsUswoPdmResponse] = await Promise.all([
    //                 axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardSWOPdmList/${facilityId}/${createdBy}?size=1000`, config),
    //                 axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardSWOPdmList/${facilityId}/${createdBy}?size=1000`, config),
    //             ]);
    //         } else if (activeTab === 6) {

    //             // Only fetch USWO data when activeTab is 4
    //             [femsUswoRiResponse, bemsUswoRiResponse] = await Promise.all([
    //                 axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardSWORIList/${facilityId}/${createdBy}?size=1000`, config),
    //                 axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardSWORIList/${facilityId}/${createdBy}?size=1000`, config),
    //             ]);
    //         }

    //         // Combine data based on activeTab
    //         let Combinedfilterdata = [];

    //         if (activeTab === 2) {
    //             Combinedfilterdata = [...femsSwoResponse.data, ...bemsSwoResponse.data];
    //         } else if (activeTab === 3) {
    //             Combinedfilterdata = [...femsSwoResponse.data, ...bemsSwoResponse.data];
    //         } else if (activeTab === 4) {
    //             Combinedfilterdata = [...femsUswoResponse.data, ...bemsUswoResponse.data];
    //         } else if (activeTab === 5) {
    //             Combinedfilterdata = [...femsUswoPdmResponse.data, ...bemsUswoPdmResponse.data];
    //         } else if (activeTab === 6) {
    //             Combinedfilterdata = [...femsUswoRiResponse.data, ...bemsUswoRiResponse.data];
    //         }

    //         // Set rows with combined data
    //         // setWorkorderrows(Combinedfilterdata);


    //         setWorkorderrows(Combinedfilterdata.map((data) => ({
    //             ...data,
    //             workorderDate: dayjs(data?.workorderDate).format('DD/MM/YYYY'),
    //             targetdate: dayjs(data?.targetdate).format('DD/MM/YYYY'),
    //             enableDownload: data?.workordercategory === "Unscheduled" || data?.workordercategory === "Scheduled",

    //           })));

    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     } finally {
    //         setGridLoder(false);
    //         setLoading(false);
    //     }
    // };

    const fetchData = async (refresh) => {
        if (!refresh) {
            setLoading(true);
        }
        setWorkorderrows([]);
        setGridLoder(true);

        try {
            // Prepare requests based on activeTab value
            let femsResponse, bemsResponse;

            if ([2, 3].includes(activeTab)) {
                // Fetch SWO data
                [femsResponse, bemsResponse] = await Promise.all([
                    axios.get(`${FemsGraph}/api/VendorDashboard/GetAllVendorDashboardUSWOListAsync/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                    axios.get(`${BemsGraph}/api/VendorDashboard/GetAllVendorDashboardUSWOListAsync/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config)
                ]);
            } else if (activeTab === 4) {
                // Fetch USWO data
                [femsResponse, bemsResponse] = await Promise.all([
                    axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardUSWOList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                    axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardUSWOList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config)
                ]);
            } else if (activeTab === 5) {
                // Fetch SWO PDM data
                [femsResponse, bemsResponse] = await Promise.all([
                    axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardSWOPdmList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                    axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardSWOPdmList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config)
                ]);
            } else if (activeTab === 6) {
                // Fetch SWO RI data
                [femsResponse, bemsResponse] = await Promise.all([
                    axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardSWORIList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                    axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardSWORIList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config)
                ]);
            } else if (activeTab === 7) {
                // Fetch SWO SCM data
                [femsResponse, bemsResponse] = await Promise.all([
                    axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardSCMWOIList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                    axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardSCMWOIList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config)
                ]);
            }

            // Combine data
            let Combinedfilterdata = [...(femsResponse?.data || []), ...(bemsResponse?.data || [])];

            // Apply filtering only for activeTab === 3 (show only "PPM" work orders)
            if (activeTab === 3) {
                Combinedfilterdata = Combinedfilterdata.filter(item => item.workordertype === "PPM");
            }

            // Format dates and apply additional conditions
            setWorkorderrows(Combinedfilterdata.map((data) => ({
                ...data,
                workorderDate: dayjs(data?.workorderDate).format('DD/MM/YYYY'),
                targetdate: dayjs(data?.targetdate).format('DD/MM/YYYY'),
                enableDownload: data?.workordercategory === "Unscheduled" || data?.workordercategory === "Scheduled",
            })));

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setGridLoder(false);
            setLoading(false);
        }
    };


    // console.log("workorderrows",workorderrows)
    const fetchtotalCount = async () => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            // Initialize responses
            let femsSwoResponse, bemsSwoResponse, femsUswoResponse, bemsUswoResponse, femsUswoPdmResponse, bemsUswoPdmResponse, femsUswoRiResponse, bemsUswoRiResponse, femsUswoScmResponse, bemsUswoScmResponse;

            // Fetch data from all APIs in parallel
            [femsSwoResponse, bemsSwoResponse, femsUswoResponse, bemsUswoResponse, femsUswoPdmResponse, bemsUswoPdmResponse, femsUswoRiResponse, bemsUswoRiResponse, femsUswoScmResponse, bemsUswoScmResponse] = await Promise.all([
                axios.get(`${FemsGraph}/api/VendorDashboard/GetAllVendorDashboardUSWOListAsync/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${BemsGraph}/api/VendorDashboard/GetAllVendorDashboardUSWOListAsync/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardUSWOList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardUSWOList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardSWOPdmList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardSWOPdmList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardSWORiList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardSWORiList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardSCMWOIList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
                axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardSCMWOIList/${facilityId}/${createdBy}/${month?.id}/${year?.value}?size=2000`, config),
            ]);

            // Extract row counts safely
            const femallwocount = femsSwoResponse?.data.length || 0;
            const bemallwocount = bemsSwoResponse?.data.length || 0;
            const femsSwoCount = femsSwoResponse?.data?.filter(item => item.workordertype === "PPM").length || 0;
            const bemsSwoCount = bemsSwoResponse?.data?.filter(item => item.workordertype === "PPM").length || 0;
            const femsUswoCount = femsUswoResponse?.data?.length || 0;
            const bemsUswoCount = bemsUswoResponse?.data?.length || 0;
            const femsUswoPdmCount = femsUswoPdmResponse?.data?.length || 0;
            const bemsUswoPdmCount = bemsUswoPdmResponse?.data?.length || 0;
            const femsUswoRiCount = femsUswoRiResponse?.data?.length || 0;
            const bemsUswoRiCount = bemsUswoRiResponse?.data?.length || 0;
            const femsUswoScmCount = femsUswoScmResponse?.data?.length || 0;
            const bemsUswoScmCount = bemsUswoScmResponse?.data?.length || 0;

            // Combine counts
            const totalCounts = femallwocount + bemallwocount;
            const scheduledCount = femsSwoCount + bemsSwoCount;
            const unscheduledCount = femsUswoCount + bemsUswoCount;
            const pdmscheduledCount = femsUswoPdmCount + bemsUswoPdmCount;
            const rischeduledCount = femsUswoRiCount + bemsUswoRiCount;
            const scmCount = femsUswoScmCount + bemsUswoScmCount;

            // Update state with calculated counts
            setAllCount(totalCounts);
            setScheduledCount(scheduledCount);
            setUnscheduledCount(unscheduledCount);
            setPdmscheduledCount(pdmscheduledCount);
            setRischeduledCount(rischeduledCount);
            setScmCount(scmCount);

        } catch (error) {
            // console.error("Error fetching data:", error);
        }
    };

    const getfemTCList = async (pageIndex, pageSize, filterModel, sortModel, initialRender) => {
        setLoading(true);
        try {
            const Userid = getCreatedBy('');
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const response = await axios.get(`${FemsGraph}/api/VendorDashboard/GetVendorDashboardT&CList/${facilityId}/${Userid}
          ?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
                filterModel
            )}&sortOptions=${JSON.stringify(sortModel)}`,
                config);
            if (initialRender && !dataCountFlag?.fem) {
                setTotalDataCount((prev) => ({ ...prev, fem: response?.data?.totalCount }));
                setDataCountFlag((prev) => ({ ...prev, fem: true }));
            }
            return response?.data;

        } catch (error) {
            //console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const getbemTCList = async (pageIndex, pageSize, filterModel, sortModel, initialRender) => {
        try {
            const Userid = getCreatedBy('');
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const response = await axios.get(`${BemsGraph}/api/VendorDashboard/GetVendorDashboardT&CList/${facilityId}/${Userid}
          ?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
                filterModel
            )}&sortOptions=${JSON.stringify(sortModel)}`,
                config);
            if (initialRender && !dataCountFlag?.bem) {
                setTotalDataCount((prev) => ({ ...prev, bem: response?.data?.totalCount }));
                setDataCountFlag((prev) => ({ ...prev, bem: true }));
            }
            return response?.data;

        } catch (error) {
            // console.log(error);
        }
    }
    const fetchExportdata = async () => {
        setIsLoading(true);
        try {
            const token = getAuthToken("id_token");
            const facilityId = getFacilityId("facilityId");
            const userId = localStorage.getItem("UserId");

            if (!token || !facilityId || !userId) {
                throw new Error("Missing required parameters: token, facilityId, or userId");
            }

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const filterOptions = JSON.stringify(filterModel || {});
            const sortOptions = JSON.stringify(sortModel || {});

            const exportUrl = generateExportUrl(service?.label, facilityId, userId, filterOptions, sortOptions);

            const exportResponse = await axios.get(exportUrl, config);
            const modifiedList = exportResponse?.data?.map((data) => ({
                ...data,
                testingcommissionstartdate: dayjs(data.testingcommissionstartdate).format('DD/MM/YYYY'),
                testingcommissioncompletedate: dayjs(data.testingcommissioncompletedate).format('DD/MM/YYYY'),
            }));

            setExportData(modifiedList);
        } catch (error) {
            // console.error("Error fetching export data:", error);
            //  showErrorNotification("Failed to fetch export data. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const generateExportUrl = (serviceLabel, facilityId, userId, filterOptions, sortOptions) => {
        const baseGraph = serviceLabel === 'FEMS' ? FemsGraph : BemsGraph;
        const endpoint = serviceLabel === 'FEMS'
            ? 'GetCommonExportFem&CList'
            : 'GetCommonExportBemT&CList';
        return `${baseGraph}/api/VendorDashboard/${endpoint}/${facilityId}/${userId}?filterOptions=${filterOptions}&sortOptions=${sortOptions}`;
    };


    const getTestingCommissionList = async () => {
        setLoading(true);
        try {
            setGridLoder(true);
            let list;
            // Fetch list based on the type parameter
            if (service?.label === 'FEMS') {
                list = await getfemTCList(pageIndex, pageSize, filterModel, sortModel);
            } else if (service?.label === 'BEMS') {
                list = await getbemTCList(pageIndex, pageSize, filterModel, sortModel);
            }
            // Modify date format
            const modifiedList = list?.items?.map((data) => ({
                ...data,
                testingcommissionstartdate: dayjs(data.testingcommissionstartdate).format('DD/MM/YYYY'),
                testingcommissioncompletedate: dayjs(data.testingcommissioncompletedate).format('DD/MM/YYYY'),
                enableDownload: data?.status === "Authorized" ? true : false,

            }));

            // Set state based on the type
            if (service?.label === 'FEMS') {
                setRows((prev) => ({ ...prev, tc: modifiedList?.length > 0 ? modifiedList : [] })); // Set rows only when fetching FEM list
                setGridLoder(false);
                if (list?.totalCount) {
                    setRowCount(list?.totalCount);
                    setExportCount(list?.totalCount);
                    setTotalDataCount((prev) => ({ ...prev, fem: list?.totalCount }));
                }
            } else if (service?.label === 'BEMS') {
                setTotalDataCount((prev) => ({ ...prev, bem: list?.totalCount }))
                list?.totalCount && setRowCount(list?.totalCount);
                list?.totalCount && setExportCount(list?.totalCount)
                setRows((prev) => ({ ...prev, tc: modifiedList?.length > 0 ? modifiedList : [] })); // Set rows only when fetching BEM list
                setGridLoder(false);
            }

        } catch (error) {
            // console.log(`Error fetching ${service?.label} testing commission details:`, error);
        } finally {
            setLoading(false);
        }
    };

    const handleSwitchChange = () => {
        // Access the checked state of the switch using event.target.checked
        // Perform actions based on the switch state (isChecked)
        dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));

    };

    // Call the async function somewhere in your component
    useEffect(() => {
        if (activeTab == 1) {
            handleTab(2)
        }
        if (year && month) {
            fetchData();
            fetchtotalCount();
            fetchMaintenanceYears();
            handleSwitchChange(); //for issue no:IF-980 i have handled this switch change whithout changing the common component
        }
        if (!dataCountFlag.fem) {
            getfemTCList(pageIndex, pageSize, filterModel, sortModel, true);
        }
        if (!dataCountFlag.bem) {
            getbemTCList(pageIndex, pageSize, filterModel, sortModel, true);
        }
    }, [activeTab, year, month]);

    useEffect(() => {
        getTestingCommissionList(); //render the default fem records
    }, [filterModel, sortModel, pageIndex, pageSize, service?.label]);




    const setBasicDetailsInfoInEditMode = async (response, rowData) => {
        const { serviceid, serviceDesc, typecode, typecodeDesc, typecodeid, vendorid, vendorname, vendorcode, workgroupid, workgroup, wgdesc } = rowData;
        const serviceData = { id: serviceid, label: serviceDesc, value: serviceDesc };
        const typecodeData = { id: typecodeid, label: typecode, value: typecodeDesc, typecode: typecode };
        const vendorData = { id: vendorid, label: `${vendorname}`, value: vendorcode, vendorname: vendorname };
        const workgroupData = { id: workgroupid, label: `${workgroup} - ${wgdesc}`, value: workgroup };
        const criticality = [{ key: 'option-0', label: 'Normal', isvisible: true, id: 1 },
        { key: 'option-1', label: 'Critical', isvisible: true, id: 2 }]
        const criticalityObj = criticality?.find((item) => item?.label === response?.riskstatus)
        const basicDetailsTc = {
            criticality: response?.riskstatus ? criticalityObj : '',
            isDateSetInEditMode: false,
            isEditMode: true,
            id: response?.id,
            testingcommissionno: response?.testingcommissionno,
            status: '',
            // basicDetails mandatory fields
            service: serviceid ? serviceData : '',
            vendorname: vendorid ? vendorData : '',
            typecode: typecodeid ? typecodeData : '',
            workgroup: workgroupid ? workgroupData : '',
            assetdesc: response?.assetdesc || '',
            testingcommissionstartdate: dayjs().format('YYYY-MM-DDTHH:mm:ss') || '',
            //non mandatory fields
            location: '',
            model: response?.model || '',
            serialno: response?.serialno || '',
            chassisno: response?.chassisno || '',
            registerno: response?.registerno || '',
            purchaseprice: response?.purchaseprice || '',
            purchaseorderno: response?.purchaseorderno || '',
            financeassetno: response?.financeassetno || '',
            manufacturer: response?.manufacturer || '',
            warrantystartdate: response?.warrantystartdate ? dayjs(response?.warrantystartdate).format('DD/MM/YYYY') : '',
            warrantyexpirydate: response?.warrantyexpirydate ? dayjs(response?.warrantyexpirydate).format('DD/MM/YYYY') : '',
            isunderwarranty: "",
            lifespan: response?.lifespan || '',
            istestpassed: response?.istestpassed !== undefined ?
                (response?.istestpassed === true ? { value: true, label: 'PASSED' } : { value: false, label: 'FAILED' }) :
                '',
            testingcommissioncompletedate: response?.testingcommissioncompletedate ? dayjs(response?.testingcommissioncompletedate).format('DD/MM/YYYY') : '',
            remarks: response?.remarks || '',
        };
        dispatch(setBasicDetailsFields(basicDetailsTc));
        return basicDetailsTc;

    }

    //method to set the otherDetails fields in edit mode
    const setOthersDetailsInfoInEditMode = async (response) => {
        const getClass = response?.class?.split(',');
        const getPowerCard = response?.powercord?.split(',');
        const getReferenceNo = response?.referenceno?.split(',');
        const getProof = response?.isdefibrillationproof;
        const proof = (getProof && getProof === true ? { value: true, label: 'YES' } : { value: false, label: 'NO' }) || '';
        const getType = response?.type?.split(',');
        const values = {
            class: {
                class1: getClass?.includes('class1'),
                class2: getClass?.includes('class2'),
                class3: getClass?.includes('class3'),
                IP: getClass?.includes('IP'),
                NA: getClass?.includes('NA')
            },
            powerCard: {
                nonDetachable: getPowerCard?.includes('nonDetachable'),
                detachable: getPowerCard?.includes('detachable'),
                strainRelief: getPowerCard?.includes('strainRelief'),
                medicalGrade: getPowerCard?.includes('medicalGrade')
            },
            referenceNo: {
                IEC60950: getReferenceNo?.includes('IEC60950'),
                IEC60601: getReferenceNo?.includes('IEC60601'),
                IEC61010: getReferenceNo?.includes('IEC61010')
            },
            type: {
                B: getType?.includes('B'),
                BF: getType?.includes('BF'),
                CF: getType?.includes('CF'),
                NA: getType?.includes('NA')
            },
            proof: proof,
            isDataSetInEditMode: true,
            isEditMode: true
        }
        dispatch(setOthersDetailsFields(values));
        return values;
    };

    const handleTCEdit = async (rowData) => {
        const response = await getTCListByID(rowData?.id, rowData?.serviceDesc === 'FEMS' ? 'FEMS' : 'BEMS');
        dispatch({ type: TCActionsTypes?.SET_TC_FIELD_VALUES, payload: { ...response[0], status: rowData?.status, isVendorLogin: true } });
        //set the values in edit mode
        const basicDetailsFieldValue = await setBasicDetailsInfoInEditMode(response[0], rowData);
        const basicDetailsFieldValueTcOthers = await setOthersDetailsInfoInEditMode(response[0]);
        navigate('register', {
            state: {
                mode: 'edit', basicDetails: { ...basicDetailsFieldValue }, TcOthers: { ...basicDetailsFieldValueTcOthers },
                tcDetails: { ...response[0], status: rowData?.status, isEditMode: true }, rowData: { ...rowData }, service: rowData?.serviceDesc
            }
        });
        dispatch(DispatchAction(TCActionsTypes.NEXT_PAGE, { currentPage: 'Basic Details' }));
    };

    const handleTab = (index) => {
        setActiveTab(index);

    };

    const columns = useMemo(() => [
        { field: 'workorderno', headerName: 'Work Order No.', width: 150 },
        {
            field: 'workorderstatus',
            headerName: 'Status',
            width: 150,
            cellRenderer: (params) => {
                if (params?.value === "Submitted" || params?.value === "Authorized" || params?.value === "Completed" || params?.value === "Closed" || params?.value === "Verified" || params?.value === "Completed-Outsource") {
                    return <SuccessChips label={params.value} />;
                } else if (params?.value === "In Progress" || params?.value === "In Progress-Outsource") {
                    return <WarningChips label={params.value} />;
                }
                else if (params?.value === "Rejected" || params?.value === "Open" || params?.value === "Not Done and Closed" || params?.value === "Cancelled" || params?.value === "Scheduled") {
                    return <ErrorChips label={params.value} />;
                }
            }
        },
        { field: 'assetno', headerName: 'Asset No', width: 150 },
        { field: 'assetdesc', headerName: 'Asset Description', width: 150 },
        { field: 'vendorname', headerName: 'Vendor Name', width: 150 },
        { field: 'technician', headerName: 'Technician Name', width: 150 },
        { field: 'requestDetails', headerName: 'Request Details', width: 150 },
        { field: 'departmentdesc', headerName: 'Department Desc', width: 150 },
        { field: 'locationdesc', headerName: 'Location Description', width: 150 },
        { field: 'serialno', headerName: 'Serial No.', width: 200 },
        {
            field: 'workorderDate', headerName: 'WorkOrder Date', width: 150,

        },
        { field: 'workordertype', headerName: 'WorkOrder Type', width: 200 },
        {
            field: 'targetdate', headerName: 'PPM Target Date', width: 150,
        },

    ], []);

    const testingColumns = useMemo(() => [
        { field: 'testingcommissionno', headerName: 'T&C No', width: 150 },
        {
            field: 'testingcommissionstartdate', headerName: 'T&C date', width: 150,
            // field: 'warrantyexpirydateFormate', headerName: 'T&C date', width: 150,
        },
        { field: 'vendorname', headerName: 'Vendor Name', width: 150 },
        { field: 'typecode', headerName: 'Type Code', width: 150 },
        { field: 'serviceDesc', headerName: 'Service', width: 200 },
        { field: 'assetdesc', headerName: 'Asset Description', width: 150 },
        { field: 'workgroup', headerName: 'Work Group', width: 150 },
        {
            field: 'istestpassed',
            headerName: 'T&C Status',
            width: 150,
            cellRenderer: (params) => {
                return params.value ? "Pass" : (params.value === false ? "Fail" : "");
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            cellRenderer: (params) => {
                if (params?.value === "Submitted" || params?.value === "Authorized") {
                    return <SuccessChips label={params?.value} />;
                } else if (params?.value === "In-Progress") {
                    return <WarningChips label={params?.value} />;
                } else {
                    return <ErrorChips label={params?.value} />
                }
            },
        }
    ], []);

    const StyledTabButton = styled(Box)(({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: '10px',
        cursor: 'pointer',
        boxShadow: "0px 4px 20px 0px #cacaca33",
        height: '100%',
        '&.active': {
            backgroundColor: theme.palette.primary.shade,
        },
    }));

    const handleWorkOrderEdit = (rowData) => {
        const getstatusId = rowData?.serviceDesc === "FEMS" ? "femworkorderstatusId" : "bemworkorderstatusId";
        if (activeTab === 6 || (activeTab === 2 && rowData?.workordertype === "Routine Inspection")) {
            navigate("routineInspectionWorkOrder", { state: { ...rowData, isEditMode: true, } });
            dispatch(routineInspectionClearWebForm("ROUTINEINSPECTION_CLEAR_WEB_FORM", {}));
            dispatch(routineInspectionCheckFormSubmitForVendor("ROUTINEINSPECTION_UPDATE_FORMSUBMIT_STATUS", rowData?.[`${getstatusId}`]));
        } else if (activeTab === 7 || (activeTab === 2 && rowData?.workordercategory === "SCM")) {
            dispatch(scmClearWebForm("SCM_CLEAR_WEB_FORM", {}));
            dispatch(scmCheckFormSubmitForVendor("SCM_UPDATE_FORMSUBMIT_STATUS", rowData?.[`${getstatusId}`]));
            navigate("SCMWorkOrder", { state: { ...rowData, isEditMode: true, } });
        }
        else {
            navigate("edit", { state: { ...rowData, isEditMode: true, } });
            dispatch(clearWebForm("CLEAR_WEB_FORM", {}));
            dispatch(checkFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", rowData?.[`${getstatusId}`]));
            console.log(rowData, "state");

        }
    };

    const handleWorkOrderview = (rowData) => {
        const getstatusId = rowData?.serviceDesc === "FEMS" ? "femworkorderstatusId" : "bemworkorderstatusId";
        if (activeTab === 6 || (activeTab === 2 && rowData?.workordertype === "Routine Inspection")) {
            navigate("ViewRIWorkOrder", { state: { ...rowData, isViewMode: true } });
            dispatch(routineInspectionCheckFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", rowData?.[`${getstatusId}`]));
        } else if (activeTab === 7 || (activeTab === 2 && rowData?.workordercategory === "SCM")) {
            dispatch(scmCheckFormSubmitForVendor("SCM_UPDATE_FORMSUBMIT_STATUS", rowData?.[`${getstatusId}`]));
            navigate("ViewSCMWorkorder", { state: { ...rowData, isViewMode: true, } });
        } else {
            navigate("view", { state: { ...rowData, isViewMode: true, } });
            dispatch(routineInspectionCheckFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", rowData?.[`${getstatusId}`]));
        }
    };

    const handleDownload = async (id) => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const femresponse = await Axios.get(`${FemsGraph}/api/TestingandCommission/GetDownloadreporttandclistfem/${id}`, config);
            const bemresponse = await Axios.get(`${BemsGraph}/api/TestingandCommission/GetDownloadreporttandclistbem/${id}`, config);
            const response = [...femresponse?.data, ...bemresponse?.data]
            if (response) {
                setData(response);

                await downloadPDF(response);
            }
        } catch (error) {
            console.error("Error downloading the report:", error);
        }
    };

    const downloadPDF = async (data) => {
        setIsView(false);
        const printRef = document.createElement("div");
        printRef.style.position = "absolute";
        printRef.style.top = "-9999px"; // Move it off-screen
        printRef.style.left = "-9999px"; // Move it off-screen
        printRef.style.zIndex = "999"; // Set desired z-index
        document.body.appendChild(printRef);


        const padding = 10;
        const contentWidth = 210 - 2 * padding;
        const contentHeight = 297 - 2 * padding;

        const tcViewComponent = (
            <Box
                sx={{
                    padding: '10px',
                    margin: '0',
                    width: `${contentWidth}mm`,
                    height: `${contentHeight}mm`,
                    backgroundColor: '#fff',
                }}
            >
                <Tcviewfile data={data} />
            </Box>
        );

        const root = createRoot(printRef);
        root.render(tcViewComponent);

        try {

            await new Promise((resolve) => setTimeout(resolve, 500));


            const canvas = await html2canvas(printRef, {
                scale: 2,
                useCORS: true,
                scrollX: 0,
                scrollY: 0,
                windowWidth: 210 * 3.7795275591,
                windowHeight: 297 * 3.7795275591,
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF({
                orientation: 'p',
                unit: 'mm',
                format: 'a4',
            });

            const imgWidth = 210 - 2 * padding;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;


            const initialY = padding;
            let heightLeft = imgHeight;
            let position = initialY;


            pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight);
            heightLeft -= (pdf.internal.pageSize.height - padding * 2);

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight);
                heightLeft -= (pdf.internal.pageSize.height - padding * 2);
            }

            pdf.save("Commissioning_Report.pdf");
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {

            document.body.removeChild(printRef);
        }
    };

    const handleDownloadedPDF = async (rowData) => {
        setPageLoading(true);

        const servicetype = rowData?.serviceDesc === "FEMS" ? "FEMS" : "BEMS";
        const checkCategory =
            rowData?.workordercategory === "Unscheduled"
                ? "GetUnScheduleWorkorderFetchByWorkOrderId"
                : "GetScheduleWorkorderFetchByWorkOrderId";

        try {
            const token = getAuthToken("id_token");
            const facilityId = getFacilityId("facilityid");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };


            const baseUrl = servicetype === "FEMS" ? FemsGraph : BemsGraph;
            const url = `${baseUrl}/api/GraphWorkorderReport/${checkCategory}/${facilityId},${rowData?.workorderId},${token}`;


            const response = await axios.get(url, config);



            setData(response?.data);
            setServiceType(rowData?.serviceDesc);
            setSelectedRowData(rowData);


            const modalComponent = rowData?.workordercategory === "Unscheduled" ? "VendorUnschedule" : "VendorWorkorder";

            setOpenReportModal(modalComponent);


            setTimeout(async () => {
                await downloadedPDF(rowData);
            }, 4000);

        } catch (error) {
            console.error("Error downloading the report:", error);

        } finally {
            //   setPageLoading(false);
        }
    };


    const downloadedPDF = async (rowData) => {
        setPageLoading(true);
        const fileName = `${rowData?.workordercategory === 'Unscheduled' ? 'Unscheduled' : 'Scheduled'}_WORK_ORDER.pdf`;

        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        });


        const printElement = printRef.current;
        if (printElement) {
            const records = printElement.querySelectorAll('.record-paper');
            let pageNumber = 1;

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const addContentToPDF = (canvas, imgData) => {
                const imgWidth = pdfWidth;
                const imgHeight = (canvas.height * pdfWidth) / canvas.width;
                let yOffset = 0;

                while (yOffset < imgHeight) {
                    if (pageNumber > 1) {
                        pdf.addPage();
                    }

                    const sliceHeight = Math.min(pdfHeight, imgHeight - yOffset);
                    pdf.addImage(
                        imgData,
                        'PNG',
                        0,
                        -yOffset,
                        imgWidth,
                        imgHeight,
                        undefined,
                        'FAST'
                    );

                    // Add footer
                    pdf.setFontSize(8);


                    pageNumber++;
                    yOffset += pdfHeight;
                }
            };

            const processRecord = async (record, index) => {
                return html2canvas(record, {
                    scale: 2,
                    useCORS: true,
                })
                    .then((canvas) => {
                        const imgData = canvas.toDataURL('image/png');
                        addContentToPDF(canvas, imgData);

                        if (index === records.length - 1) {
                            // pdf.save(fileName);
                        }
                    })
                    .catch((error) => {
                        // console.error('Error generating PDF:', error);
                    });
            };

            // Process all records and wait for all to complete
            await Promise.all(Array.from(records).map(processRecord));

            // Final PDF save with dynamic file name based on workordercategory
            pdf.save(fileName);
            setPageLoading(false); // Now, this will run only after all records are processed
            setOpenReportModal(false);

        }

    };

    const handleFieldChange = (value) => {
        if (value?.label === 'BEMS') {
            setService((prev) => {
                if (prev?.label === 'FEMS') {
                    setPageIndex(1);
                    setPageSize(10);
                    gridApi1?.setFilterModel('');
                }
            });
            setRowCount(totalDataCount?.bem)
        }
        if (value?.label === 'FEMS') {
            setService((prev) => {
                if (prev?.label === 'BEMS') {
                    setPageIndex(1);
                    setPageSize(10);
                    gridApi1?.setFilterModel('');
                }
            });
            setRowCount(totalDataCount?.fem)
        }
        setService(value);
    };

    return (
        <>
            <PageLoader open={loading} />
            <Box mt={{ xs: 2, md: 3 }} px={{ xs: 0, md: 5 }}>
                <PageLoader open={pageLoading} />
                <Grid container spacing={2}>

                    <Grid item xs={12} sm={6}>
                        <StyledTabButton p={{ xs: 1, md: 2 }} flexGrow={1} className={activeTab === 1 ? 'active' : ''} onClick={() => handleTab(1)}>
                            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                <Stack gap={1} useFlexGap>
                                    <Typography mb={1} fontWeight={500} fontSize={16}> Total Work Order Received</Typography>
                                    <Typography fontSize={36} color={'warning.main'}>{allCounts}</Typography>
                                </Stack>
                                <Avatar sx={{ bgcolor: 'warning.main' }}>
                                    <BusinessCenterIcon />
                                </Avatar>
                            </Stack>

                        </StyledTabButton>

                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <StyledTabButton p={{ xs: 1, md: 2 }} flexGrow={1} className={activeTab === 0 ? 'active' : ''} onClick={() => handleTab(0)}>
                            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                <Stack gap={1} useFlexGap>
                                    <Typography mb={1} fontWeight={500} fontSize={16}>T&C Received</Typography>
                                    <Typography fontSize={36} color={'success.main'}>{totalDataCount?.fem + totalDataCount?.bem ? totalDataCount?.fem + totalDataCount?.bem : 0}</Typography>
                                </Stack>
                                <Avatar sx={{ bgcolor: 'success.main' }}>
                                    <SettingsIcon />
                                </Avatar>
                            </Stack>
                        </StyledTabButton>
                    </Grid>
                </Grid>
                <Box my={{ xs: 2, md: 4 }} display={activeTab === 0 ? 'block' : 'none'}>
                    <DefaultCard>
                        <Box
                            mb={1}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                            }}
                        >
                            <SectionTitle title={`T&C Received (${rowCount ? rowCount : 0})`} />
                            <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                                <CustomSelectInput
                                    fullWidth={false}
                                    name="service"
                                    labelSize={"14px"}
                                    sx={{ width: 150 }}
                                    highlight={true}
                                    value={service}
                                    onChange={(value) => handleFieldChange(value)}
                                    label={"Service"}
                                    options={serviceOptions}
                                    disabled={false}
                                    isMandatoryField={false}
                                />
                                <RefreshExportButtons
                                    exportFunction={fetchExportdata}
                                    exportData={exportData}
                                    refData={gridApi1}
                                    handleRefresh={handleRefresh}
                                    title={`T&C Received `}
                                />

                            </Stack>
                        </Box>
                        <CustomAgGrid
                            rows={rows?.tc}
                            handleDownload={(row) => handleDownload(row?.id)}
                            columns={testingColumns}
                            handleEdit={handleTCEdit}
                            setGridApi={setGridApi1}
                            isLoading={gridLoader}
                            ref={gridApi1}
                            //for pagination
                            pagination={false}
                            setFilterModel={setFilterModel}
                            setSortModel={setSortModel}
                            totalCount={rowCount}
                            pageIndex={pageIndex}
                            pageSize={pageSize}
                            setPageIndex={setPageIndex}
                            setPageSize={setPageSize}
                        />
                    </DefaultCard>
                </Box>
                <Box my={{ xs: 2, md: 4 }} display={activeTab === 0 ? 'none' : 'block'} >
                    <DefaultCard>
                        <Box
                            mb={1}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                            }}
                        >
                            <SectionTitle title={activeTab === 2
                                ? `All Work Orders List (${allCounts})`
                                : activeTab === 3
                                    ? `Scheduled Work Orders List (${scheduledCount})`
                                    : activeTab === 4
                                        ? `Unscheduled Work Orders List (${unscheduledCount})`
                                        : activeTab === 5

                                            ? `Predictive Maintenance (PDM) (${pdmscheduledCount}) `
                                            : activeTab === 6
                                                ? `Routine Inspection (RI) (${rischeduledCount})`
                                                : `Scheduled Corrective Maintenance (SCM) (${scmCount})`
                            } />
                            <Stack direction={"row"} alignItems={"center"} gap={1}>
                                <CustomSelectInput
                                    fullWidth={false}
                                    labelSize={"14px"}
                                    sx={{ width: 150 }}
                                    label={"Year"}
                                    options={yearsOptions}
                                    value={year}
                                    onChange={handleYearChange}
                                    placeholder={"Select Year"}
                                    disableClearable={true}
                                    highlight={true}
                                />
                                <CustomSelectInput
                                    fullWidth={false}
                                    labelSize={"14px"}
                                    sx={{ width: 160 }}
                                    label={"Month"}
                                    options={monthsOptions}
                                    value={month}
                                    onChange={handleMonthChange}
                                    placeholder={"Select Month"}
                                    disableClearable={true}
                                    disabled={!year}
                                    highlight={true}
                                />
                                <RefreshExportButtons
                                    exportFunction={() => { }}
                                    exportData={workorderrows}
                                    refData={gridApi2}
                                    handleRefresh={handleRefresh}
                                    pagination={false}
                                    title={
                                        activeTab === 2
                                            ? `All Work Orders `
                                            : activeTab === 3
                                                ? `Scheduled Work Orders`
                                                : activeTab === 4
                                                    ? `Unscheduled Work Orders `
                                                    : activeTab === 5

                                                        ? `Predictive Maintenance (PDM) `
                                                        : activeTab === 6
                                                            ? `Routine Inspection (RI) `
                                                            : `Scheduled Corrective Maintenance (SCM) `}

                                    enablePDF={false}
                                />
                            </Stack>
                        </Box>
                        <Box mt={{ xs: 1, sm: 2 }}>
                            <DefaultCard>
                                <Grid container spacing={2}>
                                    <Grid item xs={13} md={9}>
                                        <Stack
                                            direction={"row"}
                                            divider={<Divider orientation="vertical" flexItem />}
                                            border={0.5}
                                            borderColor={"divider"}
                                            borderRadius={4}
                                            overflow={"hidden"}
                                            height={"100%"}
                                        >
                                            <StyledCardTab
                                                className={`${activeTab === 2 ? "active" : null}`}
                                                onClick={() => handleTab(2)}

                                            >
                                                <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                                    All Work Orders
                                                </Typography>
                                                <Typography
                                                    className="count"
                                                    color={"text.secondary"}
                                                    fontSize={24}
                                                    fontWeight={500}
                                                >
                                                    {allCounts}
                                                </Typography>
                                            </StyledCardTab>
                                            <StyledCardTab
                                                className={`${activeTab === 3 ? "active" : null}`}
                                                onClick={() => handleTab(3)}
                                            >
                                                <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                                    Scheduled Work Orders
                                                </Typography>
                                                <Typography
                                                    className="count"
                                                    color={"text.secondary"}
                                                    fontSize={24}
                                                    fontWeight={500}
                                                >
                                                    {scheduledCount}
                                                </Typography>
                                            </StyledCardTab>
                                            <StyledCardTab
                                                className={`${activeTab === 4 ? "active" : null}`}
                                                onClick={() => handleTab(4)}
                                            >
                                                <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                                    Unscheduled Work Orders
                                                </Typography>
                                                <Typography
                                                    className="count"
                                                    color={"text.secondary"}
                                                    fontSize={24}
                                                    fontWeight={500}
                                                >
                                                    {unscheduledCount}
                                                </Typography>
                                            </StyledCardTab>

                                            <StyledCardTab
                                                className={`${activeTab === 5 ? "active" : null}`}
                                                onClick={() => handleTab(5)}
                                            >
                                                <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                                    Predictive Maintenance (PDM)
                                                </Typography>
                                                <Typography
                                                    className="count"
                                                    color={"text.secondary"}
                                                    fontSize={24}
                                                    fontWeight={500}
                                                >
                                                    {pdmscheduledCount}
                                                </Typography>
                                            </StyledCardTab>

                                            <StyledCardTab
                                                className={`${activeTab === 6 ? "active" : null}`}
                                                onClick={() => handleTab(6)}
                                            >
                                                <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                                    Routine Inspection  (RI)
                                                </Typography>
                                                <Typography
                                                    className="count"
                                                    color={"text.secondary"}
                                                    fontSize={24}
                                                    fontWeight={500}
                                                >
                                                    {rischeduledCount}
                                                </Typography>
                                            </StyledCardTab>

                                            <StyledCardTab
                                                className={`${activeTab === 7 ? "active" : null}`}
                                                onClick={() => handleTab(7)}
                                            >
                                                <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                                                    Scheduled Corrective Maintenance (SCM)
                                                </Typography>
                                                <Typography
                                                    className="count"
                                                    color={"text.secondary"}
                                                    fontSize={24}
                                                    fontWeight={500}
                                                >
                                                    {scmCount}
                                                </Typography>
                                            </StyledCardTab>

                                        </Stack>
                                    </Grid>
                                </Grid>
                            </DefaultCard>
                            <CustomAgGrid
                                rows={workorderrows}
                                handleDownload={
                                    (activeTab === 2 || activeTab === 3 || activeTab === 4) && access?.canPrint
                                        ? (rowData) => handleDownloadedPDF(rowData)
                                        : undefined
                                }
                                columns={columns}
                                handleEdit={handleWorkOrderEdit}
                                handleView={handleWorkOrderview}
                                setGridApi={setGridApi2}
                                ref={gridApi2}
                            />
                        </Box>
                        <Modal
                            open={Boolean(openReportModal)} // Ensure modal only opens if a component is set
                            sx={{
                                "& .MuiBackdrop-root": {
                                    backgroundColor: "transparent",
                                },
                                top: "-9999px",
                                left: "-9999px",
                                zIndex: "-1",
                            }}
                        >
                            <Box sx={ModalStyle}>
                                {/* Conditionally render either Workreport or Unscheduleworkreport */}
                                {openReportModal === "VendorWorkorder" && (
                                    <VendorWorkorder
                                        ref={printRef}
                                        data={data}
                                        serviceType={serviceType}
                                        rowData={selectedRowData}
                                    />
                                )}
                                {openReportModal === "VendorUnschedule" && (
                                    <VendorUnschedule
                                        ref={printRef}
                                        data={data}
                                        serviceType={serviceType}
                                        rowData={selectedRowData}
                                    />
                                )}
                            </Box>
                        </Modal>
                    </DefaultCard>
                </Box>
            </Box>
        </>
    );
};

export default Vendordash;
